"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerPasskey = void 0;
var passkey_1 = require("./passkey");
Object.defineProperty(exports, "registerPasskey", { enumerable: true, get: function () { return passkey_1.registerPasskey; } });
